module.exports = __webpack_public_path__ + "static/js/252.e9c850fc.chunk.worker.js"